import jQuery from 'jquery'
window.jQuery = window.$ = jQuery

$('a[href*="#"]').click(function () {
  if (
    location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') &&
    location.hostname == this.hostname
  ) {
    if (this.hash.length) {
      var $target = $(this.hash)
      $target = $target.length
        ? $target
        : $('[name=' + this.hash.slice(1) + ']')

      if ($target.length) {
        var baseMinScrollTime = 200,
          baseMaxScrollTime = 500

        var docHeight = $(document).height(),
          triggerTop = $(this).offset().top,
          targetTop = $target.offset().top

        var scrollProportion = (targetTop - triggerTop) / docHeight,
          relativeTime =
            (baseMaxScrollTime - baseMinScrollTime) * scrollProportion +
            baseMinScrollTime,
          scrollTime = -1 * (1 - relativeTime)

        $('html, body').animate(
          {
            scrollTop: targetTop - 90,
          },
          scrollTime,
        )
        return false
      }
    } else {
      $('html, body').animate(
        {
          scrollTop: 0,
        },
        200,
      )
      return false
    }
  }
})
